export interface AffiliateForm {
  id: string;
  subsidiary: string;
}

export const AFFILIATE_FORM_KEY = "affiliate" as const;
